import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full grid justify-center justify-items-center" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["src", "alt"]

import {Carousel, CarouselApi, CarouselContent, CarouselItem} from "@/components/ui/carousel";
import {Card, CardContent} from "@/components/ui/card";
import {onMounted, ref} from "vue";
import TablesService from "@/services/tables/tables.service";
import {watchOnce} from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'RoofCarousel',
  props: {
    entityId: {},
    entity: {}
  },
  setup(__props: any) {

const props = __props
const photos: any = ref([]);
const emblaMainApi = ref<CarouselApi>()
const emblaThumbnailApi = ref<CarouselApi>()
const selectedIndex = ref(0)

function onSelect() {
  if (!emblaMainApi.value || !emblaThumbnailApi.value)
    return
  selectedIndex.value = emblaMainApi.value.selectedScrollSnap()
  emblaThumbnailApi.value.scrollTo(emblaMainApi.value.selectedScrollSnap())
}

function onThumbClick(index: number) {
  if (!emblaMainApi.value || !emblaThumbnailApi.value)
    return
  emblaMainApi.value.scrollTo(index)
}

watchOnce(emblaMainApi, (emblaMainApi) => {
  if (!emblaMainApi)
    return

  onSelect()
  emblaMainApi.on('select', onSelect)
  emblaMainApi.on('reInit', onSelect)
})

onMounted(async () => {
  const res = await TablesService.getAttachments(props.entity, props.entityId, 'photos');
  photos.value = res?.data
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Carousel), {
      class: "relative w-full max-w-sm h-auto",
      onInitApi: _cache[0] || (_cache[0] = (val) => emblaMainApi.value = val)
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(CarouselContent), null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photos.value, (photo) => {
              return (_openBlock(), _createBlock(_unref(CarouselItem), {
                class: "cursor-pointer",
                key: photo.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_unref(Card), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(CardContent), { class: "flex aspect-square items-center justify-center p-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: `data:${photo.mimeType};base64, ${photo.data}`,
                              alt: photo.filename,
                              class: "h-[100%] w-[100%] object-cover rounded-lg"
                            }, null, 8, _hoisted_2)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Carousel), {
      class: "relative w-full max-w-sm",
      onInitApi: _cache[1] || (_cache[1] = (val) => emblaThumbnailApi.value = val)
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(CarouselContent), { class: "flex gap-1 ml-0" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photos.value, (photo, index) => {
              return (_openBlock(), _createBlock(_unref(CarouselItem), {
                key: photo.id,
                class: "pl-0 basis-1/4 cursor-pointer",
                onClick: ($event: any) => (onThumbClick(index))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["p-1", index === selectedIndex.value ? '' : 'opacity-50'])
                  }, [
                    _createVNode(_unref(Card), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(CardContent), { class: "flex aspect-square items-center justify-center p-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: `data:${photo.mimeType};base64, ${photo.data}`,
                              alt: photo.filename,
                              class: "h-[100%] w-[100%] object-cover rounded-lg"
                            }, null, 8, _hoisted_3)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ], 2)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})